import axios from 'axios';

const restockNotification = async (email: string, key: string) => {
  const formData = new FormData();
  formData.set('email', email);
  return axios.post(`/items/${key}/request-stock-notification`, formData);
};

export default { restockNotification };
